import React, { useState, useEffect } from 'react';
import './Timeline.css';

export default function Timeline() {
  // 提取城市名
  const tzFull = Intl.DateTimeFormat().resolvedOptions().timeZone; // "America/Chicago"
  const city = tzFull.split('/').pop().replace('_', ' ');

  // 实时更新时间
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);
  const timeStr = now.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  // 获取天气
  const [weather, setWeather] = useState(null);
  useEffect(() => {
    navigator.geolocation?.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        const key = process.env.REACT_APP_OWM_API_KEY;
        fetch(
          `https://api.openweathermap.org/data/2.5/weather?` +
            `lat=${latitude}&lon=${longitude}&units=metric&appid=${key}`
        )
          .then((r) => r.json())
          .then((data) =>
            setWeather({
              temp: Math.round(data.main.temp),
              icon: data.weather[0].icon,
            })
          )
          .catch(console.error);
      },
      console.error
    );
  }, []);

  // 刻度位置（%）
  const positions = [30, 37.5, 50, 62.5, 70];

  return (
    <div className="ontology-timeline">
      {/* 全高中轴线 */}
      <div className="line" />

      {/* 五个刻度 */}
      {positions.map((p, i) => {
        const extra = i === 1 ? 'future' : i === 3 ? 'past' : '';
        return (
          <div key={i} className={`tick ${extra}`} style={{ top: `${p}%` }}>
            {/* 第二条辅助刻度上方显示 Future */}
            {i === 1 && <span className="label">Future</span>}

            {/* 中心刻度：蓝点 + NOW 区块 */}
            {i === 2 && (
              <div className="now-block">
                <div className="now-dot" />
                <span className="label">Now</span>
                <span className="label small">{timeStr}</span>
                <span className="label small">{city}</span>
                {weather && (
                  <span className="label small weather">
                    <img
                      src={`https://openweathermap.org/img/wn/${weather.icon}.png`}
                      alt=""
                    />
                    {weather.temp}°C
                  </span>
                )}
              </div>
            )}

            {/* 第四条辅助刻度下方显示 Past */}
            {i === 3 && <span className="label">Past</span>}
          </div>
        );
      })}
    </div>
  );
}
